// extracted by mini-css-extract-plugin
export default {"defaultLoading":"Loading_defaultLoading__Ct2sk"};